<div class="cs-wrapper">

  <!-- Estado de carga inicial -->
  <p-progressBar mode="indeterminate" *ngIf="loading" [style]="{ height: '3px' }"></p-progressBar>

  <!-- Tabla de diferencias (aparece tras el primer reSync) -->
  <div class="cs-table-section" *ngIf="showReSyncTable">
    <p-table
      [value]="reSyncData"
      styleClass="p-datatable p-datatable-sm p-datatable-striped"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>{{ "SYNCWALL.ENTITY" | translate }}</th>
          <th class="text-center">Total</th>
          <th class="text-center">{{ "SYNCWALL.NEW" | translate }}</th>
          <th class="text-center">{{ "SYNCWALL.UPDATE" | translate }}</th>
          <th class="text-center">{{ "SYNCWALL.DELETE" | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.label }}</td>
          <td class="text-center">{{ item.value.total }}</td>
          <td class="text-center cs-cell--new">{{ item.value.new }}</td>
          <td class="text-center cs-cell--update">{{ item.value.updated }}</td>
          <td class="text-center cs-cell--delete">{{ item.value.deleted }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Barra de progreso de sincronización -->
  <div class="cs-progress" *ngIf="loadingReSync">
    <p-progressBar mode="indeterminate" [style]="{ height: '4px' }"></p-progressBar>
  </div>

  <!-- Mensajes de resultado -->
  <div class="cs-status cs-status--error" *ngIf="syncError">
    <i class="pi pi-exclamation-triangle"></i>
    <span>{{ 'SYNCWALL.ERROR' | translate }}</span>
  </div>

  <div class="cs-status cs-status--success" *ngIf="result">
    <i class="pi pi-check-circle"></i>
    <span>{{ "SYNC_OK" | translate }}</span>
  </div>

  <!-- Acciones -->
  <div class="cs-actions">
    <p-button
      icon="pi pi-sync"
      [label]="'SYNC' | translate"
      severity="primary"
      size="small"
      [disabled]="disableSync"
      (click)="reSync()"
    ></p-button>

    <p-button
      icon="pi pi-check"
      [label]="'SYNC_OK' | translate"
      severity="success"
      size="small"
      [disabled]="sendSyncDataButton"
      (onClick)="sendSyncData()"
    ></p-button>
  </div>

</div>
